import { commit, make } from "vuex-pathify"
import TargetingAPI from "@/api/targeting"
import * as defaults from "../smart-audiences/defaults"
import { debounce } from "vue-debounce"
import hash from "object-hash"

const state = () => {
  return {
    foundGeoLocations: [],
    foundInterests: [],
    foundInterestsSuggestions: [],

    gendersList: [],
    geoLocationsTypesList: null,
    locationsTypesList: null,

    listsLoaded: false,
    searching: false,

    estimatedReach: 0,
    estimatedReachTargetingHash: null,
  }
}

const actions = {
  clearModule({ commit }) {
    commit("CLEAR_MODULE")
  },

  clearFoundGeoLocations({ commit }) {
    commit("SET_FOUND_GEO_LOCATIONS", [])
  },

  clearFoundInterests({ commit }) {
    commit("SET_FOUND_INTERESTS", [])
  },

  clearFoundInterestsSuggestions({ commit }) {
    commit("SET_FOUND_INTERESTS_SUGGESTIONS", [])
  },

  // loadLists({ commit, state }, force = false) {
  //   // @@TODO Will be in database; loading all by one endpoint
  //   if (!state.listsLoaded || force) {
  //     commit("SET_GEO_LOCATIONS_TYPES_LIST", defaults.GEO_LOCATIONS_TYPES_LIST)
  //     commit("SET_LOCATIONS_TYPES_LIST", defaults.LOCATIONS_TYPES_LIST)
  //     commit("SET_LISTS_LOADED", true)
  //   }
  // },

  searchGeoLocations({ commit }, { query, type }) {
    commit("SET_SEARCHING", true)

    type = type || "locations"

    return TargetingAPI.searchGeoLocations(query, type)
      .then(response => {
        commit("SET_FOUND_GEO_LOCATIONS", response.data)
      })
      .finally(() => {
        commit("SET_SEARCHING", false)
      })
  },

  searchInterests({ commit, rootGetters }, query) {
    commit("SET_SEARCHING", true)
    const adAccountId = rootGetters["accounts/adAccountId"]

    return TargetingAPI.searchInterests(adAccountId, query)
      .then(response => {
        commit("SET_FOUND_INTERESTS", response)
      })
      .finally(() => {
        commit("SET_SEARCHING", false)
      })
  },

  searchInterestsSuggestions({ commit, rootGetters }, interests) {
    commit("SET_SEARCHING", true)
    const adAccountId = rootGetters["accounts/adAccountId"]

    return TargetingAPI.searchInterestsSuggestions(adAccountId, interests)
      .then(response => {
        commit("SET_FOUND_INTERESTS_SUGGESTIONS", response)
      })
      .finally(() => {
        commit("SET_SEARCHING", false)
      })
  },

  getEstimatedReach({ dispatch, commit, state }, targeting) {
    if (targeting.geoLocations.length == 0) {
      commit("SET_ESTIMATED_REACH", 0)
      commit("SET_ESTIMATED_REACH_TARGETING_HASH", null)
    } else {
      const targetingHash = hash(targeting)

      if (targetingHash !== state.estimatedReachTargetingHash) {
        commit("SET_ESTIMATED_REACH", null)
        commit("SET_ESTIMATED_REACH_TARGETING_HASH", targetingHash)
        dispatch("loadEstimatedReach", targeting)
      }
    }
  },

  loadEstimatedReach: debounce(({ commit, rootGetters }, targetting) => {
    const adAccountId = rootGetters["accounts/adAccountId"]

    TargetingAPI.loadEstimatedReach(adAccountId, targetting)
      .then(estimateValue => {
        commit("SET_ESTIMATED_REACH", estimateValue)
      })
      .catch(() => {
        commit("SET_ESTIMATED_REACH", 0)
      })
  }, "600ms"),
}

const getters = {
  ...make.getters(state),
}

const mutations = {
  ...make.mutations(state),
  CLEAR_MODULE(state) {
    state.foundGeoLocations = []
    state.foundInterests = []
    state.foundInterestsSuggestions = []
    state.gendersList = []
    state.geoLocationsTypesList = null
    state.locationsTypesList = null
    state.listsLoaded = false
    state.searching = false
  },
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
